import { useSelector } from "react-redux";

import { PICKED_FAKE_REF } from "../chat/models";
import type { AgentState } from "../store/agentSlice";

type AgentRoot = { agent: AgentState };

/**
 * Whether a card's buttons belong to the picked fake model: the card was drawn on it, or its thread
 * picks it now. A card drawn before the switch has no flag of its own, so its UI reaches outside
 * (contract preview, template defaults, parsing a dropped file) only off it. Fails closed: a pick
 * still saving or the thread's saved one is the fake (a move off it counts once the server says so).
 */
export function useOnFake(
  card: { fake_model?: boolean } | null | undefined,
  threadId: number | null | undefined
): boolean {
  const picksFake = useSelector((state: AgentRoot) => {
    if (threadId == null) return false;
    return (
      state.agent.modelPicks[threadId] === PICKED_FAKE_REF ||
      state.agent.threads[threadId]?.modelRef === PICKED_FAKE_REF
    );
  });
  return card?.fake_model === true || picksFake;
}
